import React, { forwardRef }  from 'react';
import PropTypes from 'prop-types';
import getTenantTaggingSuggestion from '../../utils/getTenantTaggingSuggestion';

import './styles.css';

const TaggingSuggestion = forwardRef(function TaggingSuggestion ({show, name, environment, children}, ref) {
  const suggestedTagging = getTenantTaggingSuggestion(name);

  if (show && !environment && suggestedTagging !== environment) {
    const spanClasses =
      'custom-icon custom-icon-circle custom-icon-small custom-icon-warning custom-icon-warning-shadow';

    return (
      <div className="sc_tenant-card_tagging-suggestion" ref={ref}>
        <span className={spanClasses}>
          !
        </span>
        {children}
      </div>
    );
  }

  return children;
});

TaggingSuggestion.propTypes = {
  name: PropTypes.string.isRequired,
  show: PropTypes.bool,
  environment: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default TaggingSuggestion;
